import { render, staticRenderFns } from "./bidDetails.vue?vue&type=template&id=273c2c1f&"
import script from "./bidDetails.vue?vue&type=script&lang=js&"
export * from "./bidDetails.vue?vue&type=script&lang=js&"
import style0 from "./bidDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports